"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.styled = styled_1.default;
//# sourceMappingURL=styled.js.map